import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Plus2ReportAdmin } from "./Plus2ReportAdmin";
import { Plus2ReportPolice } from "./Plus2ReportPoliceStation";
import { GunaReportPoliceAdmin } from "./GunaReportPs";
import { GunaReportAdmin } from "./GunaReportAdmin";
import { professionalAction } from "../../_actions";
import { PoliceSideActions } from "../../_actions/police.side.actions";
import { CctnsGunaRegister } from "./cctnsGunaRegisterReport";
import { PageHeader } from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import { ArrestReportAdmin } from "./ArrestReportAdmin";
import { CctnsArrestRegister } from "./ccntsArrestReport";

class CctnsGunaReportCom extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    is_map: false,
  };

  getCctnsMapDistrict = () => {
    const { user } = this.props;
    PoliceSideActions.getCctnsMapDistrict(user?.districtId).then((res) => {
      this.setState({
        is_map: res.isMapped,
      });
    });
  };
  componentDidMount = () => {
    const { user } = this.props;
    if (user.role === "2") {
      this.getCctnsMapDistrict();
    }
  };

  render() {
    const { user } = this.props;
    console.log("user", user);
    const { is_map } = this.state;
    const { t } = this.context;

    return (
      <>
        <PageHeader
          className="site-page-header"
          ghost={false}
          onBack={false}
          title={t("arrest_register_report")}
        >
          {user.role === "2" ? (
            <>{is_map ? <CctnsArrestRegister /> : <ArrestReportAdmin />}</>
          ) : (
            <ArrestReportAdmin />
          )}
        </PageHeader>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const CctnsArrestReportCom = connect(mapStateToProps)(CctnsGunaReportCom);
export { CctnsArrestReportCom as CctnsArrestReportCom };
